import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable()
export class NoContentRouteGuard  {

  constructor(
    private _router: Router
  ) {}
  canActivate() {
    const havePools = true;
    return this.checkEnabled(havePools);
  }

  checkEnabled(havePools: any): boolean {
    if (havePools) {
      return true;
    }

    this._router.navigate(['/', 'no-content']);
    return false;
  }
}
